import React from 'react';
import { Facet, Sorting } from '@elastic/react-search-ui';
import { MultiCheckboxFacet } from '@elastic/react-search-ui-views';

import { buildSortOptionsFromConfig } from '../../config/config-helper';

const SearchFilter = ({ className }) => {

  return (
    <div className={className}>
      <Sorting
        label="Trier sur"
        sortOptions={buildSortOptionsFromConfig()}
      />
          
      <Facet field="cie_name" label="COMPAGNIE" isFilterable  />
      <Facet field="naf_activity" label="Activité" isFilterable  filterType="any" />
      <Facet field="city" label="VILLE" isFilterable view={MultiCheckboxFacet} filterType="any" />
    </div>
  );
}

export default SearchFilter;